export enum SystemSalaryPeriod {
Basic,
Leave,
Sickness,
EasterBonus,
ChristmassBonus,
Recursive,
Overtime,
BalanceBonus,
LeaveBonus,
LeaveRefund,
DismissalRefund,
PlafonRecursive,
DismissalRefundDS,
}
